import React from 'react';
import ReactDOM from 'react-dom/client';
import { RouterProvider } from '@tanstack/react-router';
import { QueryProvider } from './providers/QueryProvider';
import { AuthProvider } from './providers/AuthProvider';
import { AuthTokenSync } from './components/auth/AuthTokenSync';
import { ApplicationScopeProvider } from './contexts/ApplicationScopeContext';
import { router } from './routes/router';
import { getLegacyHostRedirect } from './lib/config';
import './index.css';

// CDEV-2228: the retired imaginariax.com hosts hand off to their pharos twin
// before anything mounts — the API no longer accepts them as CORS origins.
const legacyRedirect = getLegacyHostRedirect(window.location);
if (legacyRedirect) {
  window.location.replace(legacyRedirect);
} else {
  ReactDOM.createRoot(document.getElementById('root')!).render(
    <React.StrictMode>
      <AuthProvider>
        <QueryProvider>
          <AuthTokenSync />
          <ApplicationScopeProvider>
            <RouterProvider router={router} />
          </ApplicationScopeProvider>
        </QueryProvider>
      </AuthProvider>
    </React.StrictMode>,
  );
}
